<template>
  <div class="fileCard">
    <div v-if="msg.msgTitle" class="msgTitle">{{ msg.msgTitle }}</div>
    <img v-if="msg.msgTitle" class="msgIcon" :src="ICONS.bg" />

    <div class="msgContent">
      <div class="msgText" v-if="msg.msgText">{{ msg.msgText }}</div>
      <div class="msgText" v-if="msg.surveyExtraMsgText">{{ msg.surveyExtraMsgText }}</div>
      <div class="fileList" v-if="mediaList.length">
        <MediaList :mediaList="mediaList" />
      </div>
      <!-- 量表 -->
      <div v-if="surveyList.length" class="fileList">
        <div
          v-for="(item, idx) in surveyList"
          :key="`file-${idx}`"
          class="fileItem"
          @click="handleScaleClick(item)"
        >
          <div class="fileIcon">
            <img :src="ICONS.survey" />
          </div>
          <div class="fileName" :title="item.scaleName">{{ item.scaleName }}</div>
          <div class="surveyTag">量表</div>
        </div>
      </div>
      <!-- 文件 -->
      <div v-if="fileList.length" class="fileList">
        <div
          v-for="(item, idx) in fileList"
          :key="`file-${idx}`"
          class="fileItem"
          @click="handleFileClick(item, idx)"
        >
          <div class="fileIcon">
            <a-image
              v-if="isImageFile(item.url)"
              :ref="el => setImageRef(idx, el)"
              :src="item.url"
              :preview="{
                visible: visibleMap[idx],
                onVisibleChange: v => setImageVisible(idx, v),
                mask: false
              }"
            />
            <img v-else :src="item.icon" />
          </div>
          <div class="fileName" :title="item.name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="organizationInfo" v-if="showOrganizationInfo">
      <img v-if="msg.organizationLogo" class="organizationLogo" :src="msg.organizationLogo" />
      <div v-if="msg.organizationName" class="organizationName">
        {{ msg.organizationName }}
      </div>
    </div>
    <div class="msgLogo" v-else-if="showLogo">
      <a-image :src="showLogo" :preview="false" />
    </div>
    <!-- 随访量表弹窗 -->
    <Gauge ref="gDetail" :params="detailQuery" />
    <!-- 问卷结果iframe -->
    <Info ref="infoRef" :url="scaleResultsUrl"></Info>
  </div>
</template>
<script setup>
import { computed, defineProps, reactive, ref } from 'vue'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail'
import Info from '@/views/WorkPlace/Container/chat/components/ScaleResults/Info.vue'
import MediaList from '../mediaList/index.vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'

// ============= Constants =============
const FILE_DOMAIN = 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static'
const ICONS = {
  word: `${FILE_DOMAIN}/images/chat/wordIcon.png`,
  pdf: `${FILE_DOMAIN}/images/chat/pdfIcon.png`,
  bg: `${FILE_DOMAIN}/images/chat/fileCardBg.png`,
  survey: `${FILE_DOMAIN}/images/chat/surveyIcon.png`
}

const FILE_TYPES = {
  IMAGE: ['jpg', 'jpeg', 'png'],
  WORD: ['doc', 'docx'],
  PDF: ['pdf']
}

// ============= Props =============
const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})

// ============= Refs =============
const store = useStore()
const imageRefs = ref({})
const visibleMap = ref({})
//量表
const infoRef = ref(null)
const gDetail = ref(null)
const scaleResultsUrl = ref('')
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})

// ============= Utility Functions =============
/**
 * 获取文件名（去除路径）
 */
const getFileName = filePath => filePath?.split('/').pop() || ''

/**
 * 获取文件扩展名
 */
const getFileExtension = filePath => filePath?.split('.').pop()?.toLowerCase() || ''

/**
 * 判断是否为图片文件
 */
const isImageFile = filePath => FILE_TYPES.IMAGE.includes(getFileExtension(filePath))

/**
 * 获取文件对应的图标
 */
const getFileIcon = filePath => {
  const ext = getFileExtension(filePath)
  if (FILE_TYPES.WORD.includes(ext)) return ICONS.word
  if (FILE_TYPES.PDF.includes(ext)) return ICONS.pdf
  return filePath
}

/**
 * 检查 JSON 字符串是否为空
 */
const isEmptyJson = str => !str || str === '[]'

/**
 * 保存图片组件 ref
 */
const setImageRef = (idx, el) => {
  if (el) {
    imageRefs.value[idx] = el
  }
}

/**
 * 控制图片预览显示/隐藏
 */
const setImageVisible = (idx, visible) => {
  visibleMap.value[idx] = visible
}

// 显示组织 Logo 和名称
const showOrganizationInfo = computed(
  () => !!(props.msg.organizationName && props.msg.organizationLogo)
)

const showLogo = computed(() => {
  const logo = props.msg.msgLogo
  return !isEmptyJson(logo) ? logo : false
})
// 文件列表
const fileList = computed(() => {
  if (isEmptyJson(props.msg.fileUrl)) return []

  try {
    const files = JSON.parse(props.msg.fileUrl)
    return files.map(file => ({
      url: file,
      name: getFileName(file),
      icon: getFileIcon(file)
    }))
  } catch {
    return []
  }
})
// 量表列表
const surveyList = computed(() => {
  if (isEmptyJson(props.msg.surveyVOList)) return []

  try {
    const files = JSON.parse(props.msg.surveyVOList)
    console.log('量表', files)
    return files
  } catch {
    return []
  }
})
// 图片列表
const msgImageList = computed(() => {
  if (isEmptyJson(props.msg.imageUrl)) return []
  try {
    return JSON.parse(props.msg.imageUrl)
  } catch {
    return []
  }
})
//视频列表
const videoList = computed(() => {
  if (isEmptyJson(props.msg.mediaInfo)) return []
  try {
    return JSON.parse(props.msg.mediaInfo)
  } catch {
    return []
  }
})

//视频列表
const mediaList = computed(() => {
  const imageMedia = msgImageList.value.map(url => ({
    url,
    type: 'image'
  }))
  const videoMedia = videoList.value.map(item => ({
    url: item.mediaUrl,
    type: 'video',
    poster: item.mediaUrl + '?vframe/jpg/offset/0/w/750' // 视频封面图
  }))
  return [...videoMedia, ...imageMedia]
})
//
// ============= Event Handlers =============
/**
 * 处理文件点击事件
 * - 图片：打开预览
 * - PDF：在浏览器预览
 * - Word：直接下载
 */
const handleFileClick = (item, idx) => {
  if (isImageFile(item.url)) {
    // 图片：打开预览窗口
    visibleMap.value[idx] = true
    return
  }

  const ext = getFileExtension(item.url)

  if (FILE_TYPES.WORD.includes(ext)) {
    downloadFile(item.url, item.name)
  } else if (FILE_TYPES.PDF.includes(ext)) {
    window.open(item.url, '_blank')
  }
}

/**
 * 处理量表点击事件
 * @param {Object} item - 量表信息对象
 */
const handleScaleClick = item => {
  const { surveyType, surveyUrl, surveySendId, scaleId } = item
  if (surveyType !== 1) {
    if (!surveyUrl) return message.warning('当前量表暂不支持查看！')
    scaleResultsUrl.value = `${surveyUrl}&surveyType=${surveyType}&doctorId=${
      curGroupInfo.value.doctorInfo?.businessId || 0
    }&patientId=${curGroupInfo.value.patientInfo?.businessId}`

    return infoRef.value.showDrawer()
  }
  detailQuery.surveyId = scaleId
  detailQuery.surveySendId = surveySendId
  gDetail.value.gDetailVisible = true
}

/**
 * 下载文件
 */
const downloadFile = (url, fileName) => {
  // 保存原有的 onbeforeunload 处理
  const originalHandler = window.onbeforeunload
  window.onbeforeunload = null

  const link = document.createElement('a')
  link.href = url
  link.download = fileName || getFileName(url)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // 恢复 onbeforeunload 处理
  window.onbeforeunload = originalHandler
}
</script>
<style lang="scss" scoped>
.fileCard {
  padding: 6px;
  background: linear-gradient(180deg, #c5e7fa 0%, #ebf5f4 100%);
  position: relative;
  overflow: hidden;

  .msgTitle {
    font-weight: 500;
    font-size: 17px;
    color: #1b1b1b;
    padding: 6px 12px 10px;
    position: relative;
    z-index: 1;
  }

  .msgIcon {
    position: absolute;
    width: 128px;
    height: 40px;
    top: 13px;
    right: 0;
  }

  .msgContent {
    position: relative;
    z-index: 1;
    border-radius: 10px;
    background: #ffffff;
    padding: 12px;

    .msgText {
      margin-bottom: 8px;
      white-space: pre-wrap;
      word-break: break-word;
    }

    .fileList {
      margin-top: 4px;

      .fileItem {
        position: relative;
        display: flex;
        align-items: center;
        padding: 7px 8px;
        margin-top: 8px;
        border-radius: 8px;
        background: #f6f8fb;
        border: 1px solid #eef1f8;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: #eff2fa;
          border-color: #dce4f0;
        }

        .fileIcon {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          overflow: hidden;
          border-radius: 4px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .fileName {
          flex: 1;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          margin-left: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .surveyTag {
          position: absolute;
          right: 0;
          top: 0;
          color: #fff;
          font-size: 12px;
          font-weight: 400;
          padding: 1px 5px;
          border-radius: 0 8px 0 8px;
          background-image: linear-gradient(180deg, #05ddca 0%, #04d2b6 100%);
        }
      }
    }
  }

  .msgLogo {
    margin: 12px 6px 6px;
    max-height: 24px;
    ::v-deep(.ant-image) {
      max-height: 24px;
      width: auto;
      cursor: pointer;
    }
    ::v-deep(.ant-image-img) {
      max-height: 24px;
      width: auto;
    }
  }

  .organizationInfo {
    display: flex;
    align-items: center;
    margin: 12px 6px 6px;

    .organizationLogo {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      margin-right: 8px;
      border-radius: 4px;
      object-fit: fill;
    }

    .organizationName {
      flex: 1;
      min-width: 0;
      color: #666;
      font-size: 12px;
      word-break: break-all;
    }
  }
}
</style>
